<template>
  <div>
    <div class="content">
      <p class="fs_18">
        <i class="el-icon-warning-outline bg_red"></i>投诉须知
      </p>
      <p class="fs_13 mr_220">
        根据《工程建设项目招标投标活动投诉处理办法》，有下列情形之一的投诉，不予受理:
      </p>
      <div class="fs_13 mr_220">
        <span>
          1.投诉人不是所投诉招标投标活动的参与者，或者与投诉项目无任何利害关系；
        </span>
      </div>
      <div class="fs_13 mr_220">
        <span> 2.投诉事项不具体，且未提供有效线索，难以查证的； </span>
      </div>
      <div class="fs_13 mr_220">
        <span>
          3.投诉书未署具体投诉人真实姓名、签字和有效联系方法的；以法人名义投诉的，投诉书未经法定代表人签字并加盖公章的；
        </span>
      </div>
      <div class="fs_13 mr_220">
        <span> 4.超过投诉时效的； </span>
      </div>

      <div class="fs_13 mr_220">
        <span> 5.已作出处理决定，并且投诉人没有提出新的证据的； </span>
      </div>
      <div class="fs_13 mr_220">
        <span>
          6.投诉事项应先提出异议没有提出异议、已进入行政复议或行政诉讼程序的。
        </span>
      </div>
    </div>
    <el-form ref="form" :model="form" :rules="rules" label-width="180px">
      <el-row>
        <el-col>
          <el-form-item label="投诉人名称" prop="complainantName">
            <el-input
              v-model="form.complainantName"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="投诉人类型" prop="complainantType">
            <el-radio-group v-model="form.complainantType">
              <el-radio
                :label="item.value"
                v-for="item in typeList"
                :key="item.value"
                :value="item.value"
                >{{ item.label }}</el-radio
              >
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="在本招标项目的角色" prop="complainantRoleType">
            <el-input
              v-model="form.complainantRoleType"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="统一社会信用代码" prop="socialCreditCode">
            <el-input
              v-model="form.socialCreditCode"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="法定代表人姓名" prop="complainantLegalName">
            <el-input
              v-model="form.complainantLegalName"
              placeholder="请输入"
            ></el-input> </el-form-item
        ></el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item label="投诉人联系地址" prop="complainantContactAddress">
            <el-input
              v-model="form.complainantContactAddress"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="联系人姓名" prop="complainantUserName">
            <el-input
              v-model="form.complainantUserName"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            label="联系人公民身份号码"
            prop="complainantIdentityNumber"
          >
            <el-input
              v-model="form.complainantIdentityNumber"
              placeholder="请输入"
            ></el-input> </el-form-item
        ></el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="联系人手机号码" prop="complainantContactPhone">
            <el-input
              v-model="form.complainantContactPhone"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="联系人电子邮箱" prop="complainantContactEmail">
            <el-input
              v-model="form.complainantContactEmail"
              placeholder="请输入"
            ></el-input> </el-form-item
        ></el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import { checkPhone, Email, IDNumber, Name, creditCode } from '@/utils/rules'
export default {
  data() {
    return {
      form:
        process.env.NODE_ENV === 'production'
          ? {
              // appealsClaims: undefined, //诉求及主张
              complainantContactAddress: undefined, // 投诉人联系地址
              complainantContactEmail: undefined, //联系人邮箱
              complainantContactPhone: undefined, //联系人手机号码
              complainantIdentityNumber: undefined, // 联系人公民身份证
              complainantLegalName: undefined, //法定代表人姓名
              complainantName: undefined, //投诉人名称
              complainantRoleType: undefined, //在本招标项目的角色
              complainantType: undefined, //投诉人类型
              complainantUserName: undefined, //联系人姓名
              complaintContext: undefined, //投诉内容摘要
              complaintType: undefined, //投诉事项类型
              socialCreditCode: undefined //统一社会信用代码
            }
          : {
              // appealsClaims: '后台', //诉求及主张
              complainantContactAddress: '番禺', // 投诉人联系地址
              complainantContactEmail: '1553387475@qq.com', //联系人邮箱
              complainantContactPhone: '13420512233', //联系人手机号码
              complainantIdentityNumber: '440333199712036010', // 联系人公民身份证
              complainantLegalName: '张三', //法定代表人姓名
              complainantName: '张三', //投诉人名称
              complainantRoleType: '角色', //在本招标项目的角色
              complainantType: '法人', //投诉人类型
              complainantUserName: '漳卅', //联系人姓名
              complaintContext: '摘要', //投诉内容摘要
              complaintType: 0, //投诉事项类型
              socialCreditCode: 132155315155151515 //统一社会信用代码
            },
      rules: {
        complainantName: [
          { required: true, message: '请输入投诉人名称', trigger: 'blur' },
          {
            validator: Name,
            trigger: 'change'
          }
        ],
        complainantType: [
          { required: true, message: '请输入投诉人类型', trigger: 'blur' }
        ],
        complainantRoleType: [
          { required: true, message: '请输入招标项目的角色', trigger: 'blur' }
        ],
        socialCreditCode: [
          {
            required: true,
            message: '请输入统一社会信用代码',
            trigger: 'blur'
          },
          { validator: creditCode, trigger: 'change' }
        ],
        complainantLegalName: [
          { required: true, message: '请输入法定代表人姓名', trigger: 'blur' },
          {
            validator: Name,
            trigger: 'change'
          }
        ],
        complainantContactAddress: [
          { required: true, message: '请输入投诉人联系地址', trigger: 'blur' }
        ],
        complainantUserName: [
          { required: true, message: '请输入联系人姓名', trigger: 'blur' },
          {
            validator: Name,
            trigger: 'change'
          }
        ],
        complainantIdentityNumber: [
          {
            required: true,
            message: '请输入联系人公民身份号码',
            trigger: 'blur'
          },
          {
            validator: IDNumber,
            trigger: 'change'
          }
        ],
        complainantContactPhone: [
          {
            required: true,
            message: '请输入联系人手机号码',
            trigger: 'blur'
          },
          {
            validator: checkPhone,
            trigger: 'change'
          }
        ],
        complainantContactEmail: [
          {
            required: true,
            message: '请输入联系人电子邮箱',
            trigger: 'blur'
          },
          {
            validator: Email,
            trigger: 'change'
          }
        ]
      },
      typeList: [
        {
          value: '法人',
          label: '法人'
        },
        {
          value: '其他组织',
          label: '其他组织'
        },
        {
          value: '自然人',
          label: '自然人'
        }
      ]
    }
  },
  methods: {
    // 表单校验
    async getComplainantForm() {
      try {
        return await this.$refs.form.validate()
      } catch (error) {
        return false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
body {
  color: #333333;
}
.content {
  margin-left: 90px;
}
.mr_220 {
  margin: 0 220px;
  font-family: 'Arial Normal', 'Arial', sans-serif;
  font-weight: 400;
  font-style: normal;
}
.fs_18 {
  font-size: 18px;
  margin: 0 220px 10px;
}
.fs_13 {
  font-size: 13px;
}
div span {
  line-height: 24px;
  font-family: 'Arial Normal', 'Arial', sans-serif;
  font-weight: 400;
  font-style: normal;
}
::v-deep .el-radio__input.is-checked + .el-radio__label {
  color: #72ad43;
}
::v-deep .el-radio__input.is-checked .el-radio__inner {
  border-color: #72ad43;
  background: #72ad43;
}
.bg_red {
  color: #fff;
  background-color: red;
  border-radius: 50%;
  font-size: 24px;
  margin-right: 6px;
}
</style>
